/**
 * 서비스 점검 팝업 설정
 *
 * 점검 예정 시 아래 값을 수정하고 배포하세요.
 * 점검 완료 후 isActive를 false로 변경하면 팝업이 숨겨집니다.
 */
const maintenanceConfig = {
  /** true: 팝업 표시, false: 팝업 숨김 */
  isActive: false,

  /** 팝업 헤더 제목 (\n 으로 줄바꿈) */
  title: '서비스 안정화를 위한\n시스템 점검 안내',

  /** 안내 문구 (\n 으로 줄바꿈) */
  description:
    '안녕하세요. 후니드 입니다.\n' +
    '데일리 밀의 보다 편리한 서비스 제공을 위하여\n' +
    '시스템 점검을 시행합니다.\n' +
    '점검기간 동안 앱 서비스 이용이 제한되며,\n' +
    '빠른 시간 내 더욱 안정적인 서비스를\n' +
    '제공할 수 있도록 노력하겠습니다.',

  /** 점검 일시 (\n 으로 줄바꿈) */
  schedule: '2026년 03월 10일(화) 오후 7시\n~오후 9시(약 2시간)',

  /** 점검 내용 */
  content: '서비스 개선',
};

export default maintenanceConfig;
